module.exports = __webpack_public_path__ + "img/Rocket_MV.0d33e536.svg";